import clsx from 'clsx';
function SquareButton({ children, disabled, mode = 'interactive', className, color = 'glass-light', }) {
    const isClickable = mode === 'interactive';
    if (!children) {
        return null;
    }
    return children({
        className: clsx(
        // Default
        'inline-flex items-center gap-x-0.5 outline-none transition-(colors,transform) duration-300 justify-center text-center', 
        // Typography
        'type-button-sm sm:type-button-lg', 'relative before:content-[""] before:-z-1 z-1 before:duration-300 before:transition-(colors,transform) before:absolute before:inset-0 items-center justify-center flex-wrap text-center', 
        // Size
        'aspect-square p-0.75 w-5 sm:w-6.25', 
        // Color
        'text-text-contrast', color === 'glass-light' && 'before:bg-ui-specific-glass-light-40', color === 'glass-dark' && 'before:bg-ui-specific-glass-dark-40', 
        // Hover
        isClickable
            ? 'hover:before:bg-surface-brand-hover hover:before:-rotate-11'
            : 'group-hover/button:before:bg-surface-brand-hover group-hover/button:before:-rotate-11', 
        // Focus
        isClickable
            ? [
                'focus-visible:before:bg-surface-brand-hover focus-visible:before:-rotate-11',
                'focus-visible:before:outline-solid focus-visible:before:outline-1 focus-visible:before:outline-offset-3',
                'focus-visible:before:outline-border-muted',
            ]
            : [
                'group-focus-visible/button:before:bg-surface-brand-hover group-focus-visible/button:before:-rotate-11',
                'group-focus-visible/button:before:outline-solid group-focus-visible/button:before:outline-1 group-focus-visible/button:before:outline-offset-3',
                'group-focus-visible/button:before:outline-border-muted',
            ], 
        //Disabled
        disabled && ['pointer-events-none opacity-40'], className),
        inert: disabled ? '' : undefined,
        'aria-disabled': disabled,
    });
}
export default SquareButton;
